import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/MaterialKit/Grid/GridContainer.js";
import GridItem from "components/MaterialKit/Grid/GridItem.js";
import Button from "components/MaterialKit/CustomButtons/Button.js";
import Card from "components/MaterialKit/Card/Card.js";

import CardFooter from "components/MaterialKit/Card/CardFooter.js";

import styles from "assets/jss/material-kit-react/views/Home/teamSectionStyle.js";

import akshit from "assets/img/main/Akshit.png";
import varun from "assets/img/main/VarunRamnani.jpeg";

const useStyles = makeStyles(styles);

export default function TeamSection() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Our team</h2>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={akshit} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
                Akshit Suri
                <br />
                <small className={classes.smallTitle}>
                  Full Stack Developer
                </small>
              </h4>

              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                >
                  <a
                    href="https://www.linkedin.com/in/akshit-suri-54a5611a9/"
                    //eslint-disable-next-line
                    target="_blank"
                    rel="noopener"
                  >
                    <i className={classes.socials + " fab fa-linkedin"} />
                  </a>
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={varun} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
                Varun Ramnani
                <br />
                <small className={classes.smallTitle}>
                  Full Stack Developer
                </small>
              </h4>

              <CardFooter className={classes.justifyCenter}>
                <Button
                  justIcon
                  color="transparent"
                  className={classes.margin5}
                >
                  <a
                    href="https://www.linkedin.com/in/varun-ramnani-878653146/"
                    //eslint-disable-next-line
                    target="_blank"
                    rel="noopener"
                  >
                    <i className={classes.socials + " fab fa-linkedin"} />
                  </a>
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
